import { useState } from "react";
import { TSummaryPeriod } from "../../../constants";
import { useAdminApiQueryWithParams } from "../../../hooks";
import {
  IMerchantsOverview,
  IMerchantsSummary,
} from "../../../interfaces-and-types";
import { View } from "./View";
import { ISummarySectionProps, ISummarySectionViewProps } from "../Home";

export interface IMerchantsSummaryViewProps extends ISummarySectionViewProps<IMerchantsOverview> {}

export const MerchantsSummary = ({
  activeCurrency,
  customChartPeriod,
}: ISummarySectionProps) => {
  const [summaryPeriod, setSummaryPeriod] = useState<TSummaryPeriod>("today");

  const {
    isLoading: isLoadingMerchantsSummary,
    // isSuccess: isSuccessMerchantsSummary,
    // isError: isErrorMerchantsSummary,
    data: merchantsSummary,
    refetch: refetchSummary,
  } = useAdminApiQueryWithParams<{}, IMerchantsSummary>(
    ["getMerchantsSummary", {}],
    {},
  );
  const {
    isLoading: isLoadingMerchantsOverviewByPeriod,
    // isSuccess: isSuccessMerchantsOverviewByPeriod,
    // isError: isErrorMerchantsOverviewByPeriod,
    data: merchantsOverviewByPeriod,
    refetch: refetchOverviewByPeriod,
  } = useAdminApiQueryWithParams<
    { startDate: string; endDate: string },
    IMerchantsOverview
  >(
    [
      "getMerchantsOverviewByPeriod",
      {
        startDate: customChartPeriod.startDate,
        endDate: customChartPeriod.endDate,
      },
    ],
    {
      enabled:
        !!customChartPeriod.startDate &&
        !!customChartPeriod.endDate &&
        summaryPeriod === "custom",
    },
  );

  const refreshData =
    summaryPeriod === "custom" ? refetchOverviewByPeriod : refetchSummary;

  const summaryToDisplay =
    summaryPeriod === "today"
      ? merchantsSummary?.today
      : summaryPeriod === "past week"
        ? merchantsSummary?.past_week
        : summaryPeriod === "past month"
          ? merchantsSummary?.past_month
          : summaryPeriod === "custom"
            ? merchantsOverviewByPeriod
            : merchantsSummary?.all_time;

  const isLoadingSummary =
    summaryPeriod === "custom"
      ? isLoadingMerchantsOverviewByPeriod
      : isLoadingMerchantsSummary;

  return (
    <View
      activeCurrency={activeCurrency}
      isLoadingSummary={isLoadingSummary}
      summaryToDisplay={summaryToDisplay || null}
      summaryPeriod={summaryPeriod}
      setSummaryPeriod={setSummaryPeriod}
      refreshData={refreshData}
    />
  );
};
